import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { router } from './routes/router';
import { ThemeProvider } from './theme/ThemeProvider';
import './index.css';

/**
 * Der Server bleibt die verbindliche Quelle des Zustands (§40.3). Es wird nichts an
 * Abstimmungsdaten dauerhaft im Browser gespeichert.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 5_000,
    },
  },
});

const wurzel = document.getElementById('root');
if (wurzel === null) {
  throw new Error('Das Wurzelelement #root fehlt im HTML-Dokument.');
}

createRoot(wurzel).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
